import React from 'react'
import classnames from 'classnames'

import { constants, form } from 'helpers'
import cls from '../EventForm.module.scss'
import CardHeader from '../components/CardHeader'
import FieldTitle from '../components/FieldTitle'

const {
  EVENT_CONSTANTS: {
    SEXUAL_ORIENTATIONS: { STRAIGHT },
  },
} = constants

const MIN_PRICE = 0

const TicketQuantityInput = ({ formState, setFormState, title, genderKey, admin }) => (
  <div className={cls.fieldContainer}>
    <FieldTitle title={title} />
    <input
      className={classnames(cls.textInput, cls.ticketQuantity, 'text-center')}
      name="ticketQuantity"
      onChange={e =>
        setFormState({
          ticketQuantity: {
            ...formState.ticketQuantity,
            [genderKey]: parseInt(form.parseNumberInput(e), 10),
          },
        })
      }
      type="number"
      min="0"
      step="1"
      value={formState.ticketQuantity[genderKey].toString()}
    />
  </div>
)

const TicketSalesStep = ({ formState, setFormState, handleChange, admin }) => (
  <div className={cls.cardContainer}>
    <CardHeader stepNumber="5" title="Ticket Sales and Automation" showInfoCircle={false} />
    <div className={cls.card}>
      <div className={cls.dualFieldContainer}>
        <div className={cls.fieldContainer}>
          <FieldTitle title="Set USD Ticket Price" />
          <div className={cls.currencyInput}>
            <div className={cls.pageCurrency}>USD</div>
            <input
              className={classnames(cls.textInput, cls.ticketPrice)}
              name="ticketPrice"
              onChange={e =>
                setFormState({
                  ticketPrice: form.parseNumberInput(e),
                })
              }
              type="number"
              min={MIN_PRICE}
              value={formState.ticketPrice.toString()}
              disabled={!admin}
            />
          </div>
        </div>
      </div>
      {formState.tags.sexual_orientation?.map(orientation =>
        orientation === STRAIGHT ? (
          <React.Fragment key={orientation}>
            <div className={cls.dualFieldContainer}>
              <TicketQuantityInput
                title="Min Male Tickets"
                formState={formState}
                setFormState={setFormState}
                genderKey="MALE"
              />
              <TicketQuantityInput
                title="Min Female Tickets"
                formState={formState}
                setFormState={setFormState}
                genderKey="FEMALE"
              />
            </div>
          </React.Fragment>
        ) : null
      )}
      {admin && (
        <div className={cls.fieldContainer}>
          <input
            className={cls.textInput}
            placeholder="Bachelorette User ID"
            name="bacheloretteUserId"
            type="number"
            onChange={handleChange}
            value={formState.bacheloretteUserId}
          />
        </div>
      )}
    </div>
  </div>
)

export default TicketSalesStep
